// src/pages/ContactPage.jsx
import { useState } from "react";
import { collection, addDoc, serverTimestamp } from "../services/mysqlStore";
import { db } from "../services/mysqlStore";
import { useSocialDetails } from "../hooks/useSocialDetails";
import { useSiteContent } from "../hooks/useSiteContent";
import "./ContactPage.css";

const PhoneIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.41 2 2 0 0 1 3.6 1.21h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L7.91 8.8a16 16 0 0 0 6.29 6.29l.95-.95a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
  </svg>
);
const EmailIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect width="20" height="16" x="2" y="4" rx="2"/>
    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
  </svg>
);
const LocationIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/>
    <circle cx="12" cy="10" r="3"/>
  </svg>
);
const WhatsAppIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/>
  </svg>
);
const ClockIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/>
    <polyline points="12 6 12 12 16 14"/>
  </svg>
);
const ZapIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M13 2 3 14h9l-1 8 10-12h-9l1-8z"/>
  </svg>
);
const BrushIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22a1 1 0 0 1-1-1v-3H7a2 2 0 0 1-2-2v-3H3a1 1 0 0 1-.707-1.707l8-8a1 1 0 0 1 1.414 0l8 8A1 1 0 0 1 21 13h-2v3a2 2 0 0 1-2 2h-4v3a1 1 0 0 1-1 1z"/>
  </svg>
);
const CheckCircleIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
    <path d="m9 11 3 3L22 4"/>
  </svg>
);
const SuccessIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"
    style={{ color: "var(--cyan)" }}>
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
    <path d="m9 11 3 3L22 4"/>
  </svg>
);

export default function ContactPage() {
  var [form, setForm]           = useState({ name: "", email: "", phone: "", company: "", subject: "", message: "" });
  var [submitted, setSubmitted] = useState(false);
  var [submitting, setSubmitting] = useState(false);
  var [error, setError]         = useState("");

  var { data: sd } = useSocialDetails();
  var content = useSiteContent();

  var phone    = sd.phone    || "0800 123 4567";
  var whatsapp = sd.whatsapp || "07700 900 000";
  var email    = sd.email    || "info@circuitprinting.ca";
  var address  = sd.address  || "Unit 5, Print Park";
  var city     = sd.city     || "Toronto, Canada";
  var hours    = sd.hours    || "Mon–Fri 8am–6pm, Sat 9am–2pm";

  var handleChange = function(e) { setForm(function(f) { return { ...f, [e.target.name]: e.target.value }; }); };

  var handleSubmit = async function(e) {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) { setError("Please fill in all required fields."); return; }
    setSubmitting(true);
    setError("");
    try {
      await addDoc(collection(db, "messages"), { ...form, createdAt: serverTimestamp(), read: false });
      setSubmitted(true);
    } catch {
      setError("Something went wrong. Please call us directly.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="contact-page">
      <div className="contact-hero">
        <div className="container anim-fade-in-up">
          <span className="tag">Get In Touch</span>
          <h1 className="section-title" style={{ color: "white" }}>Contact Us</h1>
          <p className="section-subtitle" style={{ color: "rgba(255,255,255,0.65)" }}>
            {content.contactHeroText}
          </p>
        </div>
      </div>

      <div className="container contact-layout">
        {/* Info Column */}
        <div className="contact-info reveal-left">
          <h2>{content.contactIntroTitle}</h2>
          <p>{content.contactIntroText}</p>

          <div className="contact-details">
            <div className="contact-detail-item">
              <span className="detail-icon"><PhoneIcon /></span>
              <div>
                <strong>Phone</strong>
                <p><a href={"tel:" + phone.replace(/\s/g,"")} style={{color:"inherit", textDecoration:"none"}}>{phone}</a></p>
                <small>{hours}</small>
              </div>
            </div>
            <div className="contact-detail-item">
              <span className="detail-icon"><EmailIcon /></span>
              <div>
                <strong>Email</strong>
                <p><a href={"mailto:" + email} style={{color:"inherit", textDecoration:"none"}}>{email}</a></p>
                <small>We reply within 2 hours</small>
              </div>
            </div>
            <div className="contact-detail-item">
              <span className="detail-icon"><LocationIcon /></span>
              <div>
                <strong>Location</strong>
                <p>{address}</p>
                <small>{city}</small>
              </div>
            </div>
            <div className="contact-detail-item">
              <span className="detail-icon"><WhatsAppIcon /></span>
              <div>
                <strong>WhatsApp</strong>
                <p><a href={"https://wa.me/" + whatsapp.replace(/\D/g,"")} target="_blank" rel="noopener noreferrer" style={{color:"inherit", textDecoration:"none"}}>{whatsapp}</a></p>
                <small>Quick responses during business hours</small>
              </div>
            </div>
            {hours && (
              <div className="contact-detail-item">
                <span className="detail-icon"><ClockIcon /></span>
                <div>
                  <strong>Business Hours</strong>
                  <p>{hours}</p>
                </div>
              </div>
            )}
          </div>

          <div className="contact-badges">
            <div className="badge"><ZapIcon /> Same-day dispatch</div>
            <div className="badge"><BrushIcon /> Free artwork check</div>
            <div className="badge"><CheckCircleIcon /> 100% satisfaction</div>
          </div>
        </div>

        {/* Form Column */}
        <div className="contact-form-wrap reveal-right">
          {submitted ? (
            <div className="form-success anim-pop-in">
              <div className="success-icon"><SuccessIcon /></div>
              <h3>Message Sent!</h3>
              <p>Thanks <strong>{form.name}</strong>! We'll reply to <strong>{form.email}</strong> within 2 hours.</p>
            </div>
          ) : (
            <form className="contact-form" onSubmit={handleSubmit}>
              <h3>Send Us a Message</h3>
              <div className="form-row">
                <div className="form-group">
                  <label>Full Name *</label>
                  <input name="name" value={form.name} onChange={handleChange} placeholder="John Smith" required />
                </div>
                <div className="form-group">
                  <label>Company</label>
                  <input name="company" value={form.company} onChange={handleChange} placeholder="Your company" />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Email *</label>
                  <input type="email" name="email" value={form.email} onChange={handleChange} placeholder="john@company.com" required />
                </div>
                <div className="form-group">
                  <label>Phone</label>
                  <input name="phone" value={form.phone} onChange={handleChange} placeholder="07700 900000" />
                </div>
              </div>
              <div className="form-group">
                <label>Subject</label>
                <select name="subject" value={form.subject} onChange={handleChange}>
                  <option value="">Select a subject</option>
                  <option>Request a Quote</option>
                  <option>Artwork / Design Help</option>
                  <option>Order Enquiry</option>
                  <option>Delivery Question</option>
                  <option>General Enquiry</option>
                </select>
              </div>
              <div className="form-group">
                <label>Message *</label>
                <textarea name="message" value={form.message} onChange={handleChange} rows={5}
                  placeholder="Tell us about your printing project, quantities needed, deadline, etc." required />
              </div>
              {error && <p className="form-error">{error}</p>}
              <button type="submit" className="btn-primary contact-submit" disabled={submitting}>
                {submitting ? "Sending..." : "Send Message →"}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
